export interface GameEntityDelta {
  upsert?: Array<Record<string, unknown>>
  remove?: string[]
}

export interface GameStateDelta {
  players?: GameEntityDelta
  hazards?: GameEntityDelta
  strokes?: GameEntityDelta
  projectiles?: GameEntityDelta
  patch?: Record<string, unknown>
}

function entityId(entity: Record<string, unknown>, idField: string): string {
  return String(entity[idField])
}

function applyEntityDelta(
  prevList: unknown,
  entityDelta: GameEntityDelta | undefined,
  idField: string,
): Array<Record<string, unknown>> {
  const prevArr = Array.isArray(prevList)
    ? (prevList as Array<Record<string, unknown>>)
    : []
  if (!entityDelta) return prevArr

  const map = new Map(prevArr.map((item) => [entityId(item, idField), item]))

  for (const id of entityDelta.remove ?? []) {
    map.delete(id)
  }

  for (const item of entityDelta.upsert ?? []) {
    const id = entityId(item, idField)
    const existing = map.get(id)
    map.set(id, existing ? { ...existing, ...item } : { ...item })
  }

  return [...map.values()]
}

/** Сливает серверную дельту на уровне полей в локальное полное состояние. */
export function applyGameStateDelta<T extends Record<string, unknown>>(
  prev: T,
  delta: GameStateDelta,
): T {
  const next: Record<string, unknown> = {
    ...prev,
    ...(delta.patch ?? {}),
  }

  if (delta.players) {
    next.players = applyEntityDelta(prev.players, delta.players, 'playerKey')
  }
  if (delta.hazards) {
    next.hazards = applyEntityDelta(prev.hazards, delta.hazards, 'id')
  }
  if (delta.strokes) {
    next.strokes = applyEntityDelta(prev.strokes, delta.strokes, 'id')
  }
  if (delta.projectiles) {
    next.projectiles = applyEntityDelta(
      prev.projectiles,
      delta.projectiles,
      'id',
    )
  }

  return next as T
}
